$.extend($.fn.dataTable().dataTableExt.buttons.collection, {
  text: function (dt) {
    return dt.i18n('buttons.collection', 'Collection')
  },
  className: 'buttons-collection',
  action: function (e, dt, button, config) {
    var host = button
    var collectionParent = $(button).parents('div.dt-button-collection')
    var hostPosition = host.position()
    var tableContainer = $(dt.table().container())
    var multiLevel = false
    var insertPoint = host

    // Remove any old collection
    if (collectionParent.length) {
      multiLevel = $('.dt-button-collection').position()
      insertPoint = collectionParent
      $('body').trigger('click.dtb-collection')
    }

    config._collection
      .addClass(config.collectionLayout)
      .css('display', 'none')
      .insertAfter(insertPoint)
      .fadeIn(config.fade)

    var position = config._collection.css('position')

    if (multiLevel && position === 'absolute') {
      config._collection.css({
        bottom: multiLevel.top,
        left: multiLevel.left
      })
    } else if (position === 'absolute') {
      config._collection.css({
        bottom: hostPosition.top + host.outerHeight(),
        left: hostPosition.left
      })

      var tableBottom = tableContainer.offset().top + tableContainer.height()
      var listBottom =
        hostPosition.top +
        host.outerHeight() +
        config._collection.outerHeight()
      var bottomOverflow = listBottom - tableBottom

      var listTop = hostPosition.top - config._collection.outerHeight()
      var tableTop = tableContainer.offset().top
      var topOverflow = tableTop - listTop

      if (bottomOverflow > topOverflow) {
        config._collection.css(
          'top',
          hostPosition.top - config._collection.outerHeight() - 5
        )
      }

      var listRight = hostPosition.left + config._collection.outerWidth()
      var tableRight = tableContainer.offset().left + tableContainer.width()
      if (listRight > tableRight) {
        config._collection.css(
          'left',
          hostPosition.left - (listRight - tableRight)
        )
      }
    } else {
    // Fix position - centre on screen
      var top = config._collection.height() / 2
      if (top > $(window).height() / 2) {
        top = $(window).height() / 2
      }

      config._collection.css('marginTop', top * -1)
    }

    // Need to break the 'thread' for the collection button being
    // activated by a click - it would also trigger this event
    setTimeout(function () {
    // This is bonkers, but if we don't have a click listener on the
    // background element, iOS Safari will ignore the body click
    // listener below. An empty function here is all that is
    // required to make it work...
      $('div.dt-button-background').on('click.dtb-collection', function () {})

      $('body').on('click.dtb-collection', function (e) {
        // andSelf is deprecated in jQ1.8, but we want 1.7 compat
        var back = $.fn.addBack ? 'addBack' : 'andSelf'

        if (
          !$(e.target)
            .parents()[back]()
            .filter(config._collection).length
        ) {
          config._collection.fadeOut(config.fade, function () {
            config._collection.detach()
          })

          $('div.dt-button-background').off('click.dtb-collection')

          $('body').off('click.dtb-collection')
          dt.off('buttons-action.b-internal')
        }
      })
    }, 10)

    if (config.autoClose) {
      dt.on('buttons-action.b-internal', function () {
        $('div.dt-button-background').click()
      })
    }
  },
  background: true,
  collectionLayout: '',
  backgroundClassName: 'dt-button-background',
  autoClose: false,
  fade: 400,
  attr: {
    'aria-haspopup': true
  }
})



// WEBPACK FOOTER //
// ./src/script/dataTableExt.buttons.collection.js